(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosReunionDetailController",
            LebaniegoYearContactosReunionDetailController
        );

    LebaniegoYearContactosReunionDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosReunion",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosReunionDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosReunion,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosReunion = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.sectors = ["Bebidas y alimentación de Cantabria", "Sector alimentario nacional", "Sector bebidas nacionales", "Sector fabricantes de aceite", "Empresas distribución", "Otros sectores"];
        vm.results = ["Interesado", "No Interesado", "Posponer Visita"];
        
        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosReunion = Object.assign({}, vm.lebaniegoYearContactosReunion);

            LebaniegoYearContactosReunion.update(lebaniegoYearContactosReunion, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();